

document.addEventListener("DOMContentLoaded", function () {


  const sections = document.querySelectorAll(".reviews-section");

  sections.forEach((section) => {
    const slider = section.querySelector(".reviews-slider");
    const cards = slider.querySelectorAll(".review-card:not(.clone)");

    if (!cards.length) return;

    let isInitialized = false;

    // Use Intersection Observer to only initialize when section comes into view
    const initObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !isInitialized) {
            initializeSlider();
            isInitialized = true;
            initObserver.disconnect(); // Stop observing after initialization
          }
        });
      },
      {
        rootMargin: "50px", // Start initializing 50px before section is visible
      }
    );

    initObserver.observe(section);

    function initializeSlider() {
      // Detect mobile device at slider initialization time
      const isMobileSlider = window.innerWidth <= 999;

      // Mark original cards for reference
      cards.forEach((card) => card.classList.add("original"));

      // Batch DOM reads to avoid forced reflows
      let cardWidth, originalContentWidth;

      function updateCardDimensions() {
        const gap = parseInt(window.getComputedStyle(slider).gap) || 15;
        cardWidth = cards[0].offsetWidth + gap;
        originalContentWidth = cardWidth * cards.length;
      }

      // Initial dimension calculation
      updateCardDimensions();

      // Optimized cloning: Use minimal clones for better performance
      // Only 2 clones per side (4 total) instead of viewport-based calculation
      function createClones() {
        // Clear old clones
        slider
          .querySelectorAll(".review-card.clone")
          .forEach((clone) => clone.remove());

        // Use fixed clone count for better performance
        const cloneCount = isMobileSlider ? 3 : 6;

        // Clone for right side (at the end)
        for (let i = 0; i < cloneCount; i++) {
          if (cards[i]) {
            const rightClone = cards[i].cloneNode(true);
            rightClone.classList.add("clone", "right");
            rightClone.setAttribute("data-clone", "true");
            slider.appendChild(rightClone);
          }
        }

        // Clone for left side (at the beginning)
        for (let i = 0; i < cloneCount; i++) {
          const cardIndex = cards.length - 1 - i;
          if (cards[cardIndex]) {
            const leftClone = cards[cardIndex].cloneNode(true);
            leftClone.classList.add("clone", "left");
            leftClone.setAttribute("data-clone", "true");
            slider.prepend(leftClone);
          }
        }

      }

      createClones();

      window.addEventListener(
        "resize",
        debounce(() => {
          updateCardDimensions();
          createClones();
        }, 300),
        {
          passive: true,
        }
      );

      // Initialize slider state
      const allCards = slider.querySelectorAll(".review-card");
      let isDragging = false;
      let startPos = 0;
      let currentTranslate = 0;
      let prevTranslate = 0;
      let animationID;
      const autoScrollSpeed = 0.5;
      let isAutoScrolling = true;

      // Set initial position to show original content (centered)
      currentTranslate = -originalContentWidth;
      prevTranslate = currentTranslate;
      slider.style.transform = `translateX(${currentTranslate}px)`;

      // Optimize slider with GPU acceleration
      if (isMobileSlider) {
        slider.style.willChange = "transform";
      }

      // Event listeners - optimize for mobile
      if (isMobileSlider) {
        slider.addEventListener("touchstart", touchStart, { passive: false });
        slider.addEventListener("touchmove", touchMove, { passive: false });
        slider.addEventListener("touchend", touchEnd, { passive: true });
      } else {
        slider.addEventListener("touchstart", touchStart, { passive: false });
        slider.addEventListener("touchmove", touchMove, { passive: false });
        slider.addEventListener("touchend", touchEnd);
      }

      slider.addEventListener("mousedown", pointerDown);
      slider.addEventListener("mousemove", pointerMove);
      slider.addEventListener("mouseup", pointerUp);
      slider.addEventListener("mouseleave", pointerUp);


      // Helper functions
      function getPositionX(event) {
        return event.type.includes("mouse")
          ? event.pageX
          : event.touches[0].clientX;
      }

      function pointerDown(e) {
        if (e.button !== 0) return;
        startDrag(e);
      }

      function touchStart(e) {
        startDrag(e);
      }

      function startDrag(e) {
        isDragging = true;
        startPos = getPositionX(e);
        if (animationID) {
          cancelAnimationFrame(animationID);
        }
        isAutoScrolling = false;
        slider.style.cursor = "grabbing";
        slider.classList.add("no-transition");
      }

      function pointerMove(e) {
        if (!isDragging) return;
        handleDrag(e);
      }

      function touchMove(e) {
        if (!isDragging) return;
        handleDrag(e);
      }

      function handleDrag(e) {
        const currentPos = getPositionX(e);
        currentTranslate = prevTranslate + currentPos - startPos;
        slider.style.transform = `translate3d(${currentTranslate}px,0,0)`;
      }

      function pointerUp() {
        endDrag();
      }

      function touchEnd() {
        endDrag();
      }

      function endDrag() {
        if (!isDragging) return;
        isDragging = false;
        slider.style.cursor = "grab";
        slider.classList.remove("no-transition");

        checkForReset();
        startAutoScroll();
      }

      // Optimized reset function - smoother for infinite scroll
      function checkForReset() {
        const boundary = originalContentWidth;

        // Optimized boundary checking - use simple modulo reset
        if (currentTranslate > -boundary * 0.5) {
          currentTranslate -= boundary;
          slider.style.transform = `translate3d(${currentTranslate}px,0,0)`;
        } else if (currentTranslate <= -boundary * 1.5) {
          currentTranslate += boundary;
          slider.style.transform = `translate3d(${currentTranslate}px,0,0)`;
        }

        prevTranslate = currentTranslate;
      }

      function startAutoScroll() {
        isAutoScrolling = true;
        let last = performance.now();

        const step = (now) => {
          if (!isAutoScrolling) return;

          const dt = now - last;
          last = now;

          if (!isDragging) {
            currentTranslate += autoScrollSpeed * (dt / 16); // normalise to 60 fps
            prevTranslate = currentTranslate;

            slider.style.transform = `translate3d(${currentTranslate}px,0,0)`;

            checkForReset();
          }
          animationID = requestAnimationFrame(step);
        };

        animationID = requestAnimationFrame(step);
      }

      startAutoScroll();
    }
  });
});
